import ApiService from './ApiService'

// Questionnaires

export const ApiQuestionnairesLists = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab === 'active') {
            datas.is_active = true
        } else if (data.selectedTab === 'inactive') {
            datas.is_active = false
        }
        if (Array.isArray(data.branch) && data.branch.length) {
            datas.branch = data.branch.join(',')
        }
        if (data.company) {
            datas.company = data.company
        }
    }
    return ApiService.get('/portfolio_service/api/v1/questionnaire/questionnaires/', datas)
}
export const ApiQuestionnairesCreateForm = data => ApiService.post('/portfolio_service/api/v1/questionnaire/questionnaires/', data)
export const ApiQuestionnairesView = id => ApiService.get(`/portfolio_service/api/v1/questionnaire/questionnaires/${id}/`)
export const ApiQuestionnairesUpdateForm = (id, data) => ApiService.patch(`portfolio_service/api/v1/questionnaire/questionnaires/${id}/`, data)
export const ApiQuestionnairesDelete = id => ApiService.delete(`/portfolio_service/api/v1/questionnaire/questionnaires/${id}/`)

// Questions 

export const ApiQuestionsLists = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab === 'active') {
            datas.is_active = true
        } else if (data.selectedTab === 'inactive') {
            datas.is_active = false
        }
        if (Array.isArray(data.branch) && data.branch.length) {
            datas.branch = data.branch.join(',')
        }
        if (data.company) {
            datas.company = data.company
        }
    }
    return ApiService.get('/portfolio_service/api/v1/questionnaire/questions/', datas)
}

export const ApiQuestionsCreateForm = data => ApiService.post('/portfolio_service/api/v1/questionnaire/questions/', data)
export const ApiQuestionsView = id => ApiService.get(`/portfolio_service/api/v1/questionnaire/questions/${id}/`)
export const ApiQuestionsUpdateForm = (id, data) => ApiService.patch(`/portfolio_service/api/v1/questionnaire/questions/${id}/`, data)
export const ApiQuestionsDelete = id => ApiService.delete(`/portfolio_service/api/v1/questionnaire/questions/${id}/`)

// Options

export const ApiOptionsLists = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab === 'active') {
            datas.is_active = true
        } else if (data.selectedTab === 'inactive') {
            datas.is_active = false
        }
        if (Array.isArray(data.branch) && data.branch.length) {
            datas.branch = data.branch.join(',')
        }
        if (data.company) {
            datas.company = data.company
        }
    }
    return ApiService.get('/portfolio_service/api/v1/questionnaire/question-options/', datas)
}

export const ApiOptionsCreateForm = data => ApiService.post('/portfolio_service/api/v1/questionnaire/question-options/bulk-create/', data)
export const ApiOptionsView = id => ApiService.get(`/portfolio_service/api/v1/questionnaire/question-options/${id}/`)
export const ApiOptionsUpdateForm = (id, data) => ApiService.patch(`/portfolio_service/api/v1/questionnaire/question-options/${id}/`, data)
export const ApiOptionsDelete = id => ApiService.delete(`/portfolio_service/api/v1/questionnaire/question-options/${id}/`)

// Risk Category

export const ApiRiskCategoryLists = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data.selectedTab === 'active') {
            datas.is_active = true
        } else if (data.selectedTab === 'inactive') {
            datas.is_active = false
        }
        if (Array.isArray(data.branch) && data.branch.length) {
            datas.branch = data.branch.join(',')
        }
        if (data.company) {
            datas.company = data.company
        }
    }
    return ApiService.get('/portfolio_service/api/v1/questionnaire/risk-categories/', datas)
}

export const ApiRiskCategoryCreateForm = data => ApiService.post('/portfolio_service/api/v1/questionnaire/risk-categories/', data)
export const ApiRiskCategoryView = id => ApiService.get(`/portfolio_service/api/v1/questionnaire/risk-categories/${id}/`)
export const ApiRiskCategoryUpdateForm = (id, data) => ApiService.patch(`/portfolio_service/api/v1/questionnaire/risk-categories/${id}/`, data)
export const ApiRiskCategoryDelete = id => ApiService.delete(`/portfolio_service/api/v1/questionnaire/risk-categories/${id}/`)


// Risk Profile

export const ApiRiskResult = (data) => ApiService.post('/portfolio_service/api/v1/questionnaire/final-risk-profile/calculate/', data)




